<div class="flex justify-center">
  <psc-loader *ngIf="loading"></psc-loader>
</div>

<psc-stat-data-map
  [locationData]="selectedLocation"
  [statistics]="statData"></psc-stat-data-map>

<psc-stats-table
  [loading]="loading"
  [statistics]="statData"
  (locationClicked)="locationClicked($event)"></psc-stats-table>
